import { useReducer } from 'react';
import { itemsPerPageOptions } from './usePagination';

const FILTERS = {
	STATUS: 'status',
	VENDOR: 'vendor',
	TAGS: 'tags',
	COUNTRY: 'country',
	START_DATE: 'startDate',
	END_DATE: 'endDate',
	HAS_PHOTOS: 'hasPhotos',
	LIMIT: 'limit',
	OFFSET: 'offset',
	KEYWORDS: 'keywords',
	PRESET: 'preset',
	CHILD_TAG: 'child_tag',
	SORT_FIELD: 'sortField',
	SORT_ORDER: 'sortOrder',
	YEAR: 'year',
	MAKE: 'make',
	MODEL: 'model',
	EXCLUDE_TAGS: 'excludeTags',
};

function presetFilterReducer(state, action) {
	switch (action.value) {
		case 'All Orders': {
			return {
				...state,
				[action.filter]: action.value,
				status: '',
				tags: [],
				excludeTags: [],
			};
		}
		case 'New':
			return {
				...state,
				[action.filter]: action.value,
				status: [11, 7],
				tags: [],
				excludeTags: ['In Review'],
			};
		case 'In Review':
			return {
				...state,
				[action.filter]: action.value,
				status: '',
				tags: ['In Review'],
				excludeTags: [],
			};
		case 'Followups':
			return {
				...state,
				[action.filter]: action.value,
				status: '',
				tags: [
					'Followup Resolved',
					'Prefactory Followup',
					'Factory Followup',
				],
				excludeTags: [],
			};
		case 'In Production':
			return {
				...state,
				[action.filter]: action.value,
				status: [9, 3, 8],
				tags: [],
				excludeTags: [],
			};
		case 'Cancelled':
			return {
				...state,
				[action.filter]: action.value,
				status: 5,
				tags: [],
				excludeTags: [],
			};
		case 'Shipped':
			return {
				...state,
				[action.filter]: action.value,
				status: [2, 10],
				tags: [],
				excludeTags: [],
			};
		case 'CS Issue':
			return {
				...state,
				[action.filter]: action.value,
				status: '',
				tags: ['Customer Service New', 'Customer Service Pending'],
				excludeTags: [],
			};
		default:
			return {
				...state,
			};
	}
}

function filtersActionReducer(state, action) {
	if (!Object.values(FILTERS).includes(action.filter)) return state;
	if (action.filter === 'preset') return presetFilterReducer(state, action);
	return {
		...state,
		[action.filter]: action.value,
	};
}

function useSearchFilters() {
	const [filters, dispatch] = useReducer(filtersActionReducer, {
		[FILTERS.STATUS]: '',
		[FILTERS.VENDOR]: '',
		[FILTERS.TAGS]: [],
		[FILTERS.COUNTRY]: '',
		[FILTERS.START_DATE]: '',
		[FILTERS.END_DATE]: '',
		[FILTERS.HAS_PHOTOS]: false,
		[FILTERS.LIMIT]: itemsPerPageOptions[0] ?? 10,
		[FILTERS.OFFSET]: 0,
		[FILTERS.KEYWORDS]: '',
		[FILTERS.PRESET]: '',
		[FILTERS.CHILD_TAG]: [],
		[FILTERS.SORT_FIELD]: '',
		[FILTERS.SORT_ORDER]: '',
		[FILTERS.YEAR]: '',
		[FILTERS.MAKE]: '',
		[FILTERS.MODEL]: '',
		[FILTERS.EXCLUDE_TAGS]: [],
	});

	return [
		filters,
		function setFilter(filter, value) {
			dispatch({ filter, value });
		},
	];
}

export { useSearchFilters as default, FILTERS };